// extracted by mini-css-extract-plugin
module.exports = {"label":"malt-label-Label-label-5cdb686e"};